export default __webpack_public_path__ + "static/media/R9.d14d7679.png";